const { GET_CONSTANTS } = require('../Constants/constants.constants');

const initalState = {
    error: {
        code: '',
        message: ''
    },
    settings: {},
};

export default (state = initalState, action) => {
  switch (action.type) {
    case GET_CONSTANTS:
      return {
        ...state,
        settings: action.data
      }
    default:
        return state;
  }
};
